import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const TermsOfService: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f9f9f9', py: 8 }}>
      <Container maxWidth="md">
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate('/')}
          sx={{ mb: 4, color: '#9c4f96' }}
        >
          Voltar para o site
        </Button>

        <Box sx={{ bgcolor: 'white', p: 4, borderRadius: 2, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <Typography variant="h3" gutterBottom sx={{ fontWeight: 700, color: '#9c4f96', mb: 4 }}>
            Termos de Uso
          </Typography>

          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 4 }}>
            Última atualização: {new Date().toLocaleDateString('pt-BR')}
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4 }}>
            1. Aceitação dos Termos
          </Typography>
          <Typography variant="body1" paragraph>
            Ao acessar e utilizar este site, você concorda com os presentes Termos de Uso e com 
            nossa Política de Privacidade. Se você não concordar com qualquer parte destes termos, 
            não utilize este site.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4 }}>
            2. Sobre o Serviço
          </Typography>
          <Typography variant="body1" paragraph>
            Este site é operado pela cirurgiã-dentista Thayne Silva Prado (CRO/PR 38004) e tem 
            como objetivo facilitar o agendamento de consultas odontológicas. Os serviços 
            odontológicos prestados estão em conformidade com:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 3 }}>
            <li>Código de Ética Odontológica (Resolução CFO-118/2012)</li>
            <li>Lei nº 5.081/1966 (regulamenta o exercício da Odontologia)</li>
            <li>Demais normas do Conselho Federal de Odontologia (CFO)</li>
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4 }}>
            3. Agendamento de Consultas
          </Typography>
          <Typography variant="body1" paragraph>
            O agendamento através deste site:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 3 }}>
            <li>Constitui uma solicitação de consulta, sujeita à confirmação</li>
            <li>Será confirmado por nossa equipe através dos contatos fornecidos</li>
            <li>Pode ser reagendado ou cancelado mediante aviso prévio</li>
            <li>Deve ser realizado com dados verdadeiros e atualizados</li>
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4 }}>
            4. Relação Profissional-Paciente
          </Typography>
          <Typography variant="body1" paragraph>
            Em conformidade com o <strong>Art. 4º do Código de Ética Odontológica</strong>:
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontStyle: 'italic', pl: 3, borderLeft: '3px solid #9c4f96' }}>
            "A natureza personalíssima da relação paciente/profissional na atividade odontológica 
            visa demonstrar e reafirmar a peculiaridade que reveste a prestação de tais serviços, 
            diversos das demais prestações, bem como de atividade mercantil."
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4 }}>
            5. Responsabilidades do Usuário
          </Typography>
          <Typography variant="body1" paragraph>
            Ao utilizar este site, você se compromete a:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 3 }}>
            <li>Fornecer informações verdadeiras, precisas e atualizadas</li>
            <li>Comparecer aos horários agendados ou avisar sobre impossibilidade com antecedência</li>
            <li>Respeitar os horários e orientações do profissional</li>
            <li>Não utilizar o sistema de forma fraudulenta ou abusiva</li>
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4 }}>
            6. Limitação de Responsabilidade
          </Typography>
          <Typography variant="body1" paragraph>
            Este site é uma ferramenta de agendamento. O diagnóstico, tratamento e orientações 
            odontológicas só podem ser realizados em consulta presencial. Não realizamos:
          </Typography>
          <Typography variant="body1" component="ul" sx={{ pl: 3 }}>
            <li>Consultas ou diagnósticos online</li>
            <li>Prescrição de medicamentos sem avaliação presencial</li>
            <li>Orientações de tratamento por meios digitais</li>
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4 }}>
            7. Propriedade Intelectual
          </Typography>
          <Typography variant="body1" paragraph>
            Todo o conteúdo deste site (textos, imagens, logotipos, design) é de propriedade 
            exclusiva de Thayne Silva Prado e está protegido por leis de direitos autorais. 
            É proibida a reprodução sem autorização prévia.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4 }}>
            8. Modificações dos Termos
          </Typography>
          <Typography variant="body1" paragraph>
            Reservamo-nos o direito de modificar estes Termos de Uso a qualquer momento. 
            As alterações entrarão em vigor imediatamente após sua publicação neste site.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4 }}>
            9. Lei Aplicável
          </Typography>
          <Typography variant="body1" paragraph>
            Estes Termos de Uso são regidos pelas leis brasileiras. Qualquer disputa será 
            resolvida no foro da comarca de [sua cidade], Estado do Paraná.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ fontWeight: 600, mt: 4 }}>
            10. Contato
          </Typography>
          <Typography variant="body1" paragraph>
            Dúvidas sobre estes Termos de Uso podem ser enviadas para:
          </Typography>
          <Typography variant="body1" component="div" sx={{ pl: 3 }}>
            <strong>Thayne Silva Prado</strong><br />
            Cirurgiã-Dentista — CRO/PR 38004<br />
            E-mail: contato@tsodonto.com.br<br />
            Telefone: (42) 99872-0555
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default TermsOfService;